export function isExternalLink(link: string): boolean {
  return !['/', '#'].includes(link.charAt(0));
}
